import React, { Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import PrivateRoute from "./components/auth/PrivateRoute";
import Login from "./pages/Login";
import CallbackMs from "./pages/CallbackMs";
import UpdatePassword from "./pages/UpdatePassword";

import DashboardTasks from "./pages/DashboardTasks";
import Annuaire from "./pages/Annuaire";
import NotFound from "./pages/404";
import StepGeneralInformation from "./features/addEmployees/components/StepGeneralInformation";
import StepRole from "./features/addEmployees/components/StepRole";
import StepRessources from "./features/addEmployees/components/StepRessources";
import StepTasksAndModal from "./features/addEmployees/components/StepTasksAndModal";
import HrDocuments from "./features/hr_documents";
import { ROUTES } from "./constants/routes";
import Expenses from "./features/expenses";
import ExpensesHome from "./features/expenses/components/ExpenseHome";
import ExpensesDetail from "./features/expenses/components/ExpensesDetail";
import ExpensesAddCategory from "./features/expenses/components/ExpensesAddCategory";
import ExpensesReportHistory from "./features/expenses/components/ExpensesReportHistory";
import ExpensesDetailReport from "./features/expenses/pages/ExpensesDetailReport";
import ExpensesAddForm from "./features/expenses/components/ExpensesAddForm";
import ExpensesUpdateForm from "./features/expenses/components/ExpensesUpdateForm";
import ExpensesManagerMyTeams from "./features/expenses/pages/ExpensesManagerMyTeams";
import ExpensesDetailReportManager from "./features/expenses/pages/ExpensesManagerMyTeams/ExpensesDetailReportManager";
import ExpensesReportHistoryTeams from "./features/expenses/pages/ExpensesManagerMyTeams/ExpensesReportHistoryTeams";
import Leave from "./features/leave/components/absences/Parent";
import ManagerValidationTimeReporting from "./features/validate_time_reporting";
import EmployeeFolder from "./features/employee_folder";
import NewDashboard from "./features/new_dashboard";
import ManagerValidationLeaveRequest from "./features/validate_leave_request";
import PreOnboarding from "./features/pre_onboarding";
import WelcomePreonboarding from "./features/pre_onboarding/components/WelcomePreonboarding";
import Components from "./features/new_time_reporting/components";
import TimeReportingHome from "./features/new_time_reporting/pages/Home";
import Week from "./features/new_time_reporting/pages/Week";
import AnnualTracking from "./features/new_time_reporting/components/AnnualTraking";
import MyTeam from "./features/new_time_reporting/components/MyTeam";
import LoaderPage from "./components/loaders/LoaderPage";
import AddEmployees from "./features/addEmployees";
import StepContract from "./features/addEmployees/components/StepContract";
import Denied from "./pages/Denied";
import GeneralDetailTask from "./pages/DashboardTasks/Pages/GeneralDetailTask";
import ExpensesAccountingManagerHome from "./features/expenses/pages/ExpensesAccountingManagerHome/ExpensesAccountingManagerHome";
import ExpensesDetailReportAccountingManager from "./features/expenses/pages/ExpensesManagerMyTeams/ExpensesDetailReportAccountingManager";
import RemoteJob from "./features/remote_job";
import Toast from "./components/Alerts";
import { useToastGlobal } from "./stores/useToastGlobal";
import ForgetPassword from "./features/forgetPassword";
import TimeReportingSociety from "./features/new_time_reporting/components/TimeRertingSociety";
import WeekRH from "./features/new_time_reporting/pages/WeekRH";
import AccessHR from "./components/auth/AccessHR";

import NewOnboarding from "./pages/New_Onboarding";
import ToStartDetail from "./pages/New_Onboarding/components/ToStartDetail";
import Suivi from "./pages/New_Onboarding/components/suivi";
import TeamsConnection from "./features/teamsConnection/TeamsConnection";
import DelegationRoles from "./features/delegation_roles";
import DelegationHome from "./features/delegation_roles/pages/Home/DelegationHome";
import DelegationForm from "./features/delegation_roles/pages/DelegationForm/DelegationForm";
import Offboarding from "./features/offboarding";
import EntryOffboardingDetailCollabPage from "./features/offboarding/DetailCollabPage";
import ListOffboarding from "./features/offboarding/components/ListOffboarding";
import OffboardingOutlet from "./features/offboarding/pages/OffboardingOutlet/OffboardingOutlet";
import StepDeparture from "./features/offboarding/pages/StepDeparture/StepDeparture";
import StepJustificatif from "./features/offboarding/pages/StepJustificatif/StepJustificatif";
import StepSolde from "./features/offboarding/pages/StepSolde/StepSolde";
import StepEquipments from "./features/offboarding/pages/StepEquipments/StepEquipments";
import StepTasks from "./features/offboarding/pages/StepTasks/StepTasks";
import Auth2FA from "./features/2fa";
import { OffboardingArchivedCollabPage } from "./features/offboarding/DetailCollabPage/OffboardingArchivedCollabPage";
import HrDocumentsOutlet from "./features/hr_documents/pages/HrDocumentsOutlet/HrDocumentsOutlet";
import HrDocumentsSocietyOutlet from "./features/hr_documents/pages/HrDocumentsSociety/HrDocumentsSocietyOutlet";
import DetailDocument from "./features/view_document/DetailDocument";
import HrDocumentsFolders from "./features/hr_documents/pages/HrDocumentsSociety/HrDocuments";
import HrDocumentsCommonDocuments from "./features/hr_documents/pages/HrDocumentsSociety/HrDocumentsCommonDocuments";
import HrDocumentsLeave from "./features/hr_documents/pages/HrDocumentsSociety/HrDocumentsLeave";
import HrDocumentsTimesheet from "./features/hr_documents/pages/HrDocumentsSociety/HrDocumentsTimesheet";
import HrDocumentsExpenses from "./features/hr_documents/pages/HrDocumentsSociety/HrDocumentsExpenses";

const TimeReporting = React.lazy(() => import("./features/new_time_reporting"));

function App() {
    const toastConfig = useToastGlobal();
    return (
        <>
            {/* global Toast */}
            <Toast
                {...toastConfig}
                onStatusChange={toastConfig.onChangeStatus}
            />
            <BrowserRouter>
                <Routes>
                    {/* DELEGATION */}
                    <Route
                        path={ROUTES.delegation_roles.home}
                        element={
                            <Suspense fallback={<LoaderPage />}>
                                <DelegationRoles />
                            </Suspense>
                        }
                    >
                        <Route index path="" element={<DelegationHome />} />
                        <Route
                            index
                            path="assign/:type_form"
                            element={<DelegationForm />}
                        />
                    </Route>
                    {/* TEAMS SSO */}
                    <Route path={ROUTES.teams} element={<TeamsConnection />} />
                    {/* EMPLOYEE FOLDER */}
                    <Route
                        path={ROUTES.employee_folder.route}
                        element={<EmployeeFolder />}
                    />
                    {/* TIME REPORTING */}
                    <Route
                        path={ROUTES.time_reporting.home}
                        element={
                            <Suspense fallback={<LoaderPage />}>
                                <TimeReporting />
                            </Suspense>
                        }
                    >
                        <Route index path="" element={<TimeReportingHome />} />
                        <Route path="components" element={<Components />} />

                        <Route
                            path={ROUTES.time_reporting.week}
                            element={<Week />}
                        />
                        <Route
                            path={ROUTES.time_reporting.week_rh}
                            element={
                                <AccessHR>
                                    <WeekRH />
                                </AccessHR>
                            }
                        />
                        <Route
                            path={ROUTES.time_reporting.annual_tracking}
                            element={<AnnualTracking />}
                        />
                        <Route
                            path={ROUTES.time_reporting.team_tracking}
                            element={<MyTeam />}
                        />
                        <Route
                            path={ROUTES.time_reporting.entreprise}
                            element={
                                <AccessHR>
                                    <TimeReportingSociety />
                                </AccessHR>
                            }
                        />
                    </Route>

                    {/* REMOTE JOB */}
                    <Route
                        path={ROUTES.remote_job.home}
                        element={<RemoteJob />}
                    />
                    {/* note de frais, expenses */}
                    <Route path={ROUTES.expenses.home} element={<Expenses />}>
                        <Route index path="" element={<ExpensesHome />} />
                        {/* detail expense on creation. */}
                        <Route
                            path={ROUTES.expenses.detail.route}
                            element={<ExpensesDetail />}
                        />
                        {/* add expense category page */}
                        <Route
                            path={ROUTES.expenses.add_expense.route}
                            element={<ExpensesAddCategory />}
                        />
                        {/* index route, redirect to the right UPDATE form classic or other */}
                        <Route
                            path={ROUTES.expenses.update_form.route}
                            element={<ExpensesUpdateForm />}
                        />
                        {/* index route, redirect to the right ADD form classic or other */}
                        <Route
                            path={ROUTES.expenses.add_form.route}
                            element={<ExpensesAddForm />}
                        />
                        {/* history */}
                        <Route
                            path={ROUTES.expenses.my_history.route}
                            element={<ExpensesReportHistory />}
                        />
                        {/* detail of any report */}
                        <Route
                            path={ROUTES.expenses.detail_status_expense.route}
                            element={<ExpensesDetailReport />}
                        />
                        {/* home page of manager */}
                        <Route
                            path={ROUTES.expenses.manager.home.route}
                            element={<ExpensesManagerMyTeams />}
                        />
                        {/* detail any report manager side */}
                        <Route
                            path={ROUTES.expenses.manager.detail.route}
                            element={<ExpensesDetailReportManager />}
                        />
                        {/* detail any report accounting manager side */}
                        <Route
                            path={
                                ROUTES.expenses.accounting_manager.detail.route
                            }
                            element={<ExpensesDetailReportAccountingManager />}
                        />
                        {/* history of manager list by years */}
                        <Route
                            path={ROUTES.expenses.manager.history.route}
                            element={<ExpensesReportHistoryTeams />}
                        />
                        {/* ACCOUNTING MANAGER */}
                        <Route
                            path={ROUTES.expenses.accounting_manager.home.route}
                            element={<ExpensesAccountingManagerHome />}
                        />
                    </Route>

                    {/* add collaborateur with new design of fluent ! */}
                    <Route
                        path={ROUTES.employee_add}
                        element={<AddEmployees />}
                    >
                        <Route
                            index
                            path=""
                            element={<StepGeneralInformation />}
                        />
                        <Route
                            path="first"
                            element={<StepGeneralInformation />}
                        />
                        <Route path="second" element={<StepContract />} />
                        <Route path="third" element={<StepRole />} />
                        <Route path="fourth" element={<StepRessources />} />
                        <Route path="fifth" element={<StepTasksAndModal />} />
                    </Route>
                    {/* Preaparer un offboarding */}
                    {/* Preaparer un offboarding */}
                    {/* Preaparer un offboarding */}
                    <Route
                        path={ROUTES.offboarding.prepare_offboarding}
                        element={<OffboardingOutlet />}
                    >
                        <Route index path="" element={<StepDeparture />} />
                        <Route path="departure" element={<StepDeparture />} />
                        <Route
                            path="justification"
                            element={<StepJustificatif />}
                        />
                        <Route path="leave_balances" element={<StepSolde />} />
                        <Route
                            path="equipments_access"
                            element={<StepEquipments />}
                        />
                        <Route path="attribute_tasks" element={<StepTasks />} />
                    </Route>
                    {/* 2FA */}
                    {/* 2FA */}
                    {/* 2FA */}
                    <Route path={ROUTES.auth2fa.home} element={<Auth2FA />} />

                    {/* ANNUAIRE */}
                    <Route path={ROUTES.annuaire} element={<Annuaire />} />

                    {/* en of forget password */}
                    <Route
                        path={ROUTES.task_manager}
                        element={<DashboardTasks />}
                    />
                    {/* detail task */}
                    <Route
                        path="/tasks/:id_task/user/:id_user/detail"
                        element={<GeneralDetailTask />}
                    />
                    {/* DASHBOARD */}
                    <Route path="/dashboard" element={<NewDashboard />} />
                    {/* DETAIL DOCUMENT */}
                    <Route
                        path={ROUTES.detail_document.home}
                        element={<DetailDocument />}
                    />
                    {/* DOCUMENT HR + ENTREPRISE */}
                    <Route
                        path={ROUTES.document_hr.home}
                        element={<HrDocumentsOutlet />}
                    >
                        <Route
                            index
                            path={ROUTES.document_hr.home}
                            element={<HrDocuments />}
                        />
                        <Route
                            path={ROUTES.document_hr.society}
                            element={<HrDocumentsSocietyOutlet />}
                        >
                            <Route
                                index
                                path={""}
                                element={
                                    <HrDocumentsFolders rootIndex={true} />
                                }
                            />
                            <Route
                                index
                                path={"hr_documents"}
                                element={<HrDocumentsFolders />}
                            />
                            <Route
                                path={"common_documents"}
                                element={<HrDocumentsCommonDocuments />}
                            />
                            <Route
                                path={"expenses"}
                                element={<HrDocumentsExpenses />}
                            />
                            <Route
                                path={"leave"}
                                element={<HrDocumentsLeave />}
                            />
                            <Route
                                path={"timesheet"}
                                element={<HrDocumentsTimesheet />}
                            />
                        </Route>
                    </Route>
                    {/* preonboarding  */}
                    <Route path="/preonboarding" element={<PreOnboarding />} />
                    <Route
                        path="/welcome-preonboarding"
                        element={<WelcomePreonboarding />}
                    />
                    {/* end preonboarding */}
                    {/* LEAVE */}
                    <Route path="/leave" element={<Leave />} />
                    {/* new onboarding page  */}
                    <Route
                        path={ROUTES.onboarding.home}
                        element={<NewOnboarding />}
                    />

                    {/* offboarding  */}
                    {/* offboarding  */}
                    {/* offboarding  */}
                    <Route
                        path={ROUTES.offboarding.home}
                        element={<Offboarding />}
                    >
                        <Route
                            index
                            path={ROUTES.offboarding.detail}
                            element={<EntryOffboardingDetailCollabPage />}
                        />
                        <Route
                            index
                            path={ROUTES.offboarding.archived}
                            element={<OffboardingArchivedCollabPage />}
                        />
                        <Route
                            path={ROUTES.offboarding.home}
                            element={<ListOffboarding />}
                        />
                    </Route>

                    {/* préonboarding task detail page  */}
                    <Route
                        path={ROUTES.onboarding.detail}
                        element={<ToStartDetail />}
                    />
                    {/* suivi page  */}
                    <Route path={ROUTES.onboarding.suivi} element={<Suivi />} />

                    {/* * NO NEED AUTH * */}
                    {/* * NO NEED AUTH * */}
                    {/* * NO NEED AUTH * */}
                    {/* * NO NEED AUTH * */}
                    {/* * NO NEED AUTH * */}
                    {/* * NO NEED AUTH * */}
                    <Route path="/" element={<Login />} />
                    {/* <LoginPage /> */}
                    {/* <PreOnboarding /> */}
                    <Route path="/login" element={<Login />} />

                    <Route path="/callback_ms" element={<CallbackMs />} />

                    <Route
                        path="/updatePassword"
                        element={<UpdatePassword />}
                    />
                    <Route
                        path="/timesheet_approval/:hash"
                        element={<ManagerValidationTimeReporting />}
                    />
                    <Route
                        path="/leave_request_approval/:hash"
                        element={<ManagerValidationLeaveRequest />}
                    />
                    {/* forget password */}
                    <Route
                        path={ROUTES.forget_password}
                        element={<ForgetPassword />}
                    />
                    <Route path="/denied" element={<Denied />} />
                    <Route path="*" element={<NotFound />} />
                </Routes>
            </BrowserRouter>
        </>
    );
}

export default App;
